import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { useIntl, Link } from 'gatsby-plugin-intl'
import { LinkPlaceholder } from 'src/components/Typography'
import routes from 'src/utils/routes'
import HeaderLoggedIn, {
  HeaderGroup
} from 'src/components/header/HeaderLoggedIn'
import { Page } from 'src/components/Wrappers'
import { AddOfferButton } from 'src/components/atoms/Buttons'
import { MENU_ITEMS } from 'src/features/dashboard/duck/consts'
import PermissionsContext from 'src/utils/permissions'

import StockHeader from 'src/features/stocks/components/StockHeader.jsx'
import { EXCHANGE_API_URL_PREFIXES } from 'src/ducks/consts'
import { canAddOffer } from 'src/features/offers/utils/exchangePermissions'
import Drawer from './components/Drawer'
import OfferHistoryDetails from './components/OfferDetails/OfferHistoryDetails'
import useActiveDrawerOffer from './components/OfferDetails/useActiveDrawerOffer'
import ExportOffersList from './components/lists/ExportOffersList'
import ExchangeOffersView from './components/map/ExchangeOffersView'
import { EXCHANGE_MAP_TYPES } from './components/map/offerMapUtils'
import { connectExport } from './ducks/connectors'
import { ListWrapper, ContentWrapper } from './components/atoms'
import ExportFilters from './components/filters/Export'

const StockCargoExport = ({
  className,
  isDrawerOpen,
  setDrawerState,
  getOffers,
  offers,
  pagination,
  selectedOfferId,
  setFilter,
  showOffer,
  stock
}) => {
  const intl = useIntl()
  const {
    drawerOfferType,
    resetDrawerOffer,
    selectDrawerOffer,
    selectHistoryOffer,
    selectedOfferId: activeOfferId,
    selectedOfferType: activeOfferType
  } = useActiveDrawerOffer(EXCHANGE_MAP_TYPES.EXPORT, selectedOfferId)
  const permissions = useContext(PermissionsContext)
  const hasPermissionToAddOffer = canAddOffer(
    EXCHANGE_API_URL_PREFIXES.EXPORT,
    permissions
  )
  useEffect(() => {
    getOffers()
    return () => {
      setDrawerState(false)
    }
  }, [])
  const closeDrawer = () => {
    resetDrawerOffer()
    setDrawerState(false)
  }
  return (
    <Page
      className={className}
      contentPadding={0}
      topBar={
        <HeaderLoggedIn>
          <HeaderGroup withMobileAction={hasPermissionToAddOffer}>
            <StockHeader withDropdown>
              {intl.formatMessage({
                id: 'offers.freightExchangeExportTitle'
              })}
            </StockHeader>
            {hasPermissionToAddOffer && (
              <Link
                to={`${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.OFFER_FORM_EXPORT}`}
              >
                <AddOfferButton />
              </Link>
            )}
          </HeaderGroup>
        </HeaderLoggedIn>
      }
    >
      <ContentWrapper>
        <ListWrapper>
          <ExchangeOffersView
            exchangeType={EXCHANGE_MAP_TYPES.EXPORT}
            drawerOfferType={activeOfferType}
            filters={<ExportFilters />}
            isDrawerOpen={isDrawerOpen}
            onDrawerOfferTypeChange={selectDrawerOffer}
            offers={offers}
            pagination={pagination}
            selectedOfferId={activeOfferId}
            selectedOfferType={activeOfferType}
            setDrawerState={setDrawerState}
            setFilter={setFilter}
            showOffer={showOffer}
            stock={stock}
          >
            <ExportOffersList trigger={isDrawerOpen} />
          </ExchangeOffersView>
        </ListWrapper>
        <Drawer open={isDrawerOpen} onClose={closeDrawer}>
          <OfferHistoryDetails
            defaultOfferType={EXCHANGE_MAP_TYPES.EXPORT}
            isOpen={isDrawerOpen}
            offerType={drawerOfferType}
            onActiveOfferChange={selectHistoryOffer}
            onClose={closeDrawer}
            onOfferTypeChange={selectDrawerOffer}
            selectedOfferId={`${activeOfferType}:${activeOfferId || ''}`}
          />
        </Drawer>
      </ContentWrapper>
    </Page>
  )
}

const StyledStockCargoExport = styled(StockCargoExport)`
  ${LinkPlaceholder} {
    margin-bottom: 1.2rem;
  }
`

export default connectExport(StyledStockCargoExport)
